<template>
  <div class="print-wrapper">
    <!-- 物料清单表格 -->
    <table class="material-table">
      <thead>
        <tr>
          <th width="60">当前物料</th>
          <th width="60">物料名称</th>
          <th width="80">规格</th>
          <th width="40">单位</th>
          <th width="60">数量</th>
          <th width="60">单价</th>
          <th width="60">金额</th>
          <th width="60">领料数</th>
          <th width="60">仓位</th>
          <th>备注</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item, index) in wuliaoData" :key="index">
          <td>{{ index + 1 }}</td>
          <td>{{ item.name }}</td>
          <td>{{ item.spec }}</td>
          <td>{{ item.unit }}</td>
          <td>{{ item.counts }}</td>
          <td>{{ item.goods_price }}</td>
          <td>{{ item.goods_amount }}</td>
          <td>{{ item.get_counts }}</td>
          <td>{{ item.warehuose_name }}</td>
          <td>{{ item.remark }}</td>
        </tr>
      </tbody>
    </table>

    <!-- 物料采购表格 -->
    <table class="purchase-table">
      <tbody>
        <tr>
          <th width="60">当前工序</th>
          <th width="60">工艺名称</th>
          <th width="80">规格</th>
          <th width="40">单位</th>
          <th width="60">数量</th>
          <th width="60">单价</th>
          <th width="60">金额</th>
          <th width="60">报工数</th>
          <th width="60">工时</th>
          <th>备注</th>
        </tr>
        <tr v-for="(item, index) in [data.gongyiData]" :key="index">
          <td>{{ index + 1 }}</td>
          <td>{{ item.name }}</td>
          <td>{{ item.spec }}</td>
          <td>{{ item.unit }}</td>
          <td>{{ item.counts }}</td>
          <td>{{ item.goods_price }}</td>
          <td>{{ item.goods_amount }}</td>
          <td>{{ item.sheng_chan_end_counts }}</td>
          <td>{{ item.gongshi }}</td>
          <td>{{ item.remark }}</td>
        </tr>
      </tbody>
    </table>

    <!-- 质检要求表格 -->
    <table class="inspection-table">
      <thead>
        <tr>
          <th width="60">质检要求</th>
          <th width="149">检测项目</th>
          <th width="109">标准范围</th>
          <th width="129">实测范围</th>
          <th>检测结果</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="index in 2" :key="index">
          <td>{{ index }}</td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: 'PrintTable',
  props: {
    data: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      wuliaoData: []
    }
  },
  mounted() {
    this.initTableData()
  },
  methods: {
    /**
     * 初始化当前物料清单数据
     */
    initTableData() {
      let data = this.data.tableSaleData[0] || {}

      // 当前物料
      if (data.tableBomData.length) {
        this.wuliaoData = data.tableBomData || []
        return
      }
      if (data.table_data_2.length) {
        this.wuliaoData = data.table_data_2 || []
        return
      }
      this.wuliaoData = data.table_data_1 || []
    }
  }
}
</script>

<style lang="less" scoped>
.print-wrapper {
}

// 物料清单表格
.material-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: -1px;

  th,
  td {
    border: 1px solid #000;
    padding: 4px;
    font-size: 12px;
    text-align: center;
  }

  th {
    font-weight: bold;
    background: #e0e5eb;
  }
}

// 物料采购表格
.purchase-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: -1px;

  th,
  td {
    border: 1px solid #000;
    padding: 4px;
    font-size: 12px;
    text-align: center;
  }

  th {
    font-weight: bold;
    background: #e0e5eb;
  }
}

// 质检要求表格
.inspection-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: -1px;

  th,
  td {
    border: 1px solid #000;
    padding: 4px;
    font-size: 12px;
    text-align: center;
  }

  th {
    font-weight: bold;
    background: #e0e5eb;
  }
}
</style>
